// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sivsm30 {
  font-size: 15px;
  margin-bottom: 20px;
  font-weight: var(--_18w76bw3z);
}
@media screen and (min-width: 768px) {
  .sivsm30 {
    font-size: 17px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".sivsm30 {\n  font-size: 15px;\n  margin-bottom: 20px;\n  font-weight: var(--_18w76bw3z);\n}\n@media screen and (min-width: 768px) {\n  .sivsm30 {\n    font-size: 17px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
